"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.MenuItem = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var classnames_1 = __importDefault(require("classnames"));
/**
 * Menu Button component for display multiple options
 * @param props
 */
var MenuItem = function (props) {
    var classnames = (0, classnames_1["default"])('chakra-select-button chakra-item-button', props.className);
    return ((0, jsx_runtime_1.jsx)("button", __assign({ type: "button", role: "menuitem", onClick: props.onSelect, disabled: props.disabled, className: classnames }, { children: props.children })));
};
exports.MenuItem = MenuItem;
//# sourceMappingURL=menu-item.js.map